import {
  Home, Layers, Zap, Warehouse, Car, Sun, Wrench, HardHat,
  PanelsTopLeft, SunMedium, Shield, TreePine,
} from "lucide-react";

export const COMPANY = {
  name: "Zimmerei Müller GmbH & Co. KG",
  claim: "Mehr als Dächer",
  address: "Talstraße 5, 97799 Zeitlofs-Weißenbach",
  phone: "09744 / 766",
  phoneLink: "+499744766",
  fax: "09744 / 93 09 53",
  mobileAndreas: "0151 / 65 65 9514",
  mobileAndreasLink: "+4915165659514",
  mobileRichard: "0174 / 98 99 986",
  mobileRichardLink: "+4917498999986",
  email: "info@zimmerei-mueller-zeitlofs.de",
};

export const SERVICES = [
  { icon: Home, title: "Anbau & Umbau", text: "Zusätzlicher Wohnraum — harmonisch und fachgerecht an bestehende Strukturen angeschlossen." },
  { icon: Layers, title: "Aufstockungen", text: "Neues Stockwerk auf bestehendem Gebäude — mehr Wohnraum ohne zusätzliche Grundstücksfläche." },
  { icon: Zap, title: "Energetische Dachsanierung", text: "Wärmeverluste minimieren, Energieeffizienz steigern — fachgerechte Dämmung und Sanierung." },
  { icon: Warehouse, title: "Hallenbau", text: "Gewerbliche Hallen und Lagerbauten — von der Planung bis zur schlüsselfertigen Übergabe." },
  { icon: Car, title: "Carports", text: "Funktionale und stilvolle Fahrzeugunterstände — als Ergänzung für Haus und Grundstück." },
  { icon: Sun, title: "Dachgauben & Dachfenster", text: "Mehr Licht, mehr Wohnraum — fachgerechte Integration in bestehende Dachstrukturen." },
  { icon: Wrench, title: "Spenglerarbeiten", text: "Dachrinnen, Kehlbleche, Wandanschlüsse — präzise Ausführung für optimale Wasserableitung." },
  { icon: HardHat, title: "Dachdeckerarbeiten", text: "Eindecken, Reparatur und Wartung — langlebiger Schutz vor allen Witterungseinflüssen." },
  { icon: PanelsTopLeft, title: "Trockenbau", text: "Flexible Innenraumgestaltung, Leichtbauwände, abgehängte Decken — schnell und präzise." },
  { icon: SunMedium, title: "Photovoltaik-Montage", text: "Professionelle Montage von PV-Anlagen — Trägersysteme, Module und Verkabelung auf dem Dach." },
  { icon: Shield, title: "Blechdächer", text: "Robust, langlebig und modern — präziser Zuschnitt und fachgerechte Abdichtung." },
  { icon: TreePine, title: "Terrassen, Balkone & Wintergärten", text: "Überdachungen, Wintergärten und Balkone — ganzjährige Nutzung und wohnliche Erweiterung." },
];

// Original-Bilder (Referenz): zimmerei-mueller-zeitlofs.de/wp-content/uploads/2025/03/
export const GALLERY = [
  // zimmerei-mueller-zeitlofs-anbau-1-550x550.jpg
  { src: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=800&auto=format&fit=crop", title: "Anbau & Umbau", cat: "HOLZBAU" },
  // zimmerei-mueller-zeitlofs-aufstockung-3-550x550.jpg
  { src: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=800&auto=format&fit=crop", title: "Aufstockung", cat: "HOLZBAU" },
  // zimmerei-mueller-zeitlofs-energetische-dachsanierung-1-550x550.jpg
  { src: "https://images.unsplash.com/photo-1518780664697-55e3ad937233?q=80&w=800&auto=format&fit=crop", title: "Energetische Dachsanierung", cat: "DACH" },
  // zimmerei-mueller-zeitlofs-hallenbau-5-550x550.jpg
  { src: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=800&auto=format&fit=crop", title: "Hallenbau", cat: "HOLZBAU" },
  // zimmerei-mueller-zeitlofs-carport-1-550x550.jpg
  { src: "https://images.unsplash.com/photo-1449844908441-8829872d2607?q=80&w=800&auto=format&fit=crop", title: "Carport", cat: "SONSTIGES" },
  // zimmerei-mueller-zeitlofs-dachfenster-4-550x550.jpg
  { src: "https://images.unsplash.com/photo-1416331108676-a22ccb276e35?q=80&w=800&auto=format&fit=crop", title: "Dachgauben & Dachfenster", cat: "DACH" },
  // zimmerei-mueller-zeitlofs-spenglerarbeiten-4-550x550.jpg
  { src: "https://images.unsplash.com/photo-1487958449943-2429e8be8625?q=80&w=800&auto=format&fit=crop", title: "Spenglerarbeiten", cat: "DACH" },
  // zimmerei-mueller-zeitlofs-dachdecker-1-550x550.jpg
  { src: "https://images.unsplash.com/photo-1523217582562-09d0def993a6?q=80&w=800&auto=format&fit=crop", title: "Dachdeckerarbeiten", cat: "DACH" },
  // zimmerei-mueller-zeitlofs-trockenbau-2-550x550.jpg
  { src: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=800&auto=format&fit=crop", title: "Trockenbau", cat: "SONSTIGES" },
  // zimmerei-mueller-zeitlofs-photovoltaik-1-1-550x550.jpg
  { src: "https://images.unsplash.com/photo-1509391366360-2e959784a276?q=80&w=800&auto=format&fit=crop", title: "Photovoltaik", cat: "DACH" },
  // zimmerei-mueller-zeitlofs-blechdach-2-550x550.jpg
  { src: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?q=80&w=800&auto=format&fit=crop", title: "Blechdach", cat: "DACH" },
  // zimmerei-mueller-zeitlofs-wintergarten-3-550x550.jpg
  { src: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=800&auto=format&fit=crop", title: "Wintergarten", cat: "SONSTIGES" },
];
